import { render, staticRenderFns } from "./index.vue?vue&type=template&id=259a5510"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259a5510')) {
      api.createRecord('259a5510', component.options)
    } else {
      api.reload('259a5510', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=259a5510", function () {
      api.rerender('259a5510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/evaluations/addEvaluation/consultantWithClassTime/index.vue"
export default component.exports